import { render, staticRenderFns } from "./OriginalDocuments.vue?vue&type=template&id=04ffaff4&scoped=true&"
import script from "./OriginalDocuments.vue?vue&type=script&lang=js&"
export * from "./OriginalDocuments.vue?vue&type=script&lang=js&"
import style0 from "./OriginalDocuments.vue?vue&type=style&index=0&id=04ffaff4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ffaff4",
  null
  
)

export default component.exports